import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { OperatingSystemsActions } from '../actions';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.OperatingSystem };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
  paginationIdPrev?: number;
  paginationIdNext?: number;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    OperatingSystemsActions.CreateOperatingSystem,
    OperatingSystemsActions.ReadOperatingSystem,
    OperatingSystemsActions.ReadOperatingSystems,
    OperatingSystemsActions.UpdateOperatingSystem,
    OperatingSystemsActions.DeleteOperatingSystem,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(
    OperatingSystemsActions.ReadOperatingSystemSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false,
        loaded: false
      };
    }
  ),
  on(
    OperatingSystemsActions.ReadOperatingSystemsSuccess,
    (state, { response }) => {
      const items = response['hydra:member'];
      const entities = items.reduce(
        (
          entities: { [iri: string]: fromModuleModels.OperatingSystem },
          item
        ) => {
          return {
            ...entities,
            [item['@id']]: item
          };
        },
        { ...state.entities }
      );

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    OperatingSystemsActions.CreateOperatingSystemSuccess,
    OperatingSystemsActions.UpdateOperatingSystemSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(OperatingSystemsActions.DeleteOperatingSystemSuccess, (state, { iri }) => {
    const { [iri]: removedItem, ...entities }: any = state.entities;

    return {
      ...state,
      entities,
      loading: false,
      loaded: true
    };
  }),
  on(
    OperatingSystemsActions.CreateOperatingSystemFail,
    OperatingSystemsActions.ReadOperatingSystemFail,
    OperatingSystemsActions.ReadOperatingSystemsFail,
    OperatingSystemsActions.UpdateOperatingSystemFail,
    OperatingSystemsActions.DeleteOperatingSystemFail,
    (state, { response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false,
        loaded: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
